import { archivesSelectForm, selectValues, newsArchives } from './lib/newsSearch.js';
import './lib/pagination.js';

window.addEventListener('load',  () => {
  // ページ読み込み時の処理
  const values = selectValues();
  // 結果を表示します
  newsArchives(values);
  // アーカイブの選択
  archivesSelectForm.addEventListener('change', () => {
    // 再取得
    const values = selectValues();
    // 結果を表示します
    newsArchives(values);
  });
});
